import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AppLayout } from '@amzn/awsui-components-react';

export function UnsupportedSignupLayout() {
  const { t } = useTranslation('signup');

  return (
    <AppLayout
      footerSelector=".footer"
      navigationHide={true}
      toolsHide={true}
      content={<Alert type="info">{t('manageSignupsPage.unsupportedSignupType')}</Alert>}
    />
  );
}
